import {initializeApp} from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
} from "firebase/auth";

// Firebase web config is non-secret client config, injected at build time from
// REACT_APP_FIREBASE_* env vars (sourced from the Terraform module outputs).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(firebaseApp);

// Firebase rejects real Phone Auth SMS from the hostname "localhost"
// (auth/invalid-app-credential). In local CRA this skips reCAPTCHA so the
// fictional test numbers in staging.tfvars can complete sign-in. Real numbers
// still fail on localhost — use 127.0.0.1, a LAN host, or staging.savaquan.com.
// The Mars test PWA is a production build with the same need (SQ-537): its
// index.html carries a sentinel that the container's entrypoint sets to 1 on
// the test lanes only (docker/api-base-url.sh). A window global, not a
// REACT_APP_* variable: the build inlines those as string literals and the
// minifier folds `'__SENTINEL__' === '1'` to false, dropping the branch.
const phoneAuthTestMode =
  (window as Window & { __SAVAQUAN_PHONE_AUTH_TEST__?: string }).__SAVAQUAN_PHONE_AUTH_TEST__ === '1';
if (process.env.NODE_ENV === 'development' || phoneAuthTestMode) {
  firebaseAuth.settings.appVerificationDisabledForTesting = true;
}

export const googleAuthProvider = new GoogleAuthProvider();
